import { Outlet, NavLink, useNavigate } from 'react-router-dom'
import { LayoutDashboard, Building2, Users, ArrowLeft } from 'lucide-react'
import { classNames } from '../../lib/utils'
import { useAuth } from '../../lib/auth'

const platformTabs = [
  { to: '/platform', icon: LayoutDashboard, label: 'Dashboard', end: true },
  { to: '/platform/orgs', icon: Building2, label: 'Orgs' },
  { to: '/platform/users', icon: Users, label: 'Users' },
]

export default function PlatformShell() {
  const navigate = useNavigate()
  const { signOut } = useAuth()

  return (
    <div className="min-h-screen bg-surface-container-low">
      <header className="bg-inverse-surface text-inverse-on-surface px-5 py-3.5 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <button onClick={() => navigate('/')} className="w-8 h-8 flex items-center justify-center rounded-full bg-inverse-on-surface/10" aria-label="Back to app">
            <ArrowLeft size={16} />
          </button>
          <span className="text-sm font-bold tracking-[0.08em] uppercase">Placed Platform</span>
        </div>
        <button
          onClick={signOut}
          className="text-xs text-inverse-primary font-semibold tracking-wide"
        >
          Sign Out
        </button>
      </header>
      <nav className="bg-inverse-surface px-5 flex gap-1 overflow-x-auto">
        {platformTabs.map(tab => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.end}
            className={({ isActive }) => classNames(
              'flex items-center gap-1.5 px-3.5 py-3 text-xs font-semibold whitespace-nowrap transition-colors tracking-wide rounded-t-md',
              isActive
                ? 'bg-inverse-on-surface/10 text-inverse-primary'
                : 'text-inverse-on-surface/50 hover:text-inverse-on-surface hover:bg-inverse-on-surface/5'
            )}
          >
            <tab.icon size={14} />
            <span>{tab.label}</span>
          </NavLink>
        ))}
      </nav>
      <main className="px-4 pt-5 pb-8 max-w-screen-md mx-auto">
        <Outlet />
      </main>
    </div>
  )
}
